import { hotelService } from "@/_services/supplier/hotel.service.js";
import { _alert } from "@/_helpers/function";

export default {
    name: 'hotelList',
    data() {
        return {
            locale: this.$i18n.locale,
            hotels: [],
            sites: [],
            currentPage: 1,
            currentPageH: 1,
            currentPageSite: 1,
            totalRowsHotel: 0,
            totalRowsSite: 0,
            perPage: 5,
            perPageH: 5,
            pageOptions: [5, 10, 15, 20],
            filter: '',
            filterOn: ['HOTEL_NAME', 'HOTEL_ID'],
            filterSite: '',
            filterOnSite: ['HOTEL_NAME', 'HOTEL_ID'],
            user: {},
            loading: true,
        };
    },
    created() {
        let currentUser = JSON.parse(localStorage.getItem("userInfo"));
        this.user = currentUser.user;
        this.getAllSite(1);
        this.getAllHotel(1);
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRowsHotel = filteredItems.length;
            this.currentPage = 1;
        },
        onFilteredSite(filteredItems) {
            this.totalRowsSite = filteredItems.length;
            this.currentPageSite = 1;
        },
        getAllHotel(page) {
            this.loading = true;
            this.currentPageH = page;
            const body = {
                lang: this.$i18n.locale,
                value: this.filter,
                types: [...this.filterOn],
                limit: this.perPageH,
                offset: (page - 1) * this.perPageH,
            }
            hotelService.getHotel(body).then(
                response => {
                    if (response.responseCode === 0) {
                        this.hotels = response.data.sites;
                        this.totalRowsHotel = response.data.total;
                    } else {
                        this.$bvToast.toast(this.$t(response.data), {
                            title: this.$t('INFO_WARNING'),
                            variant: 'warning',
                            solid: true,
                            autoHideDelay: 1500,
                        });
                    }
                    this.loading = false;
                },
                error => {
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        },
        getAllSite(page) {
            this.loading = true;
            this.currentPageSite = page;
            const body = {
                lang: this.$i18n.locale,
                value: this.filterSite,
                types: [...this.filterOnSite],
                limit: this.perPage,
                offset: (page - 1) * this.perPage,
            }
            hotelService.getSite(body).then(
                response => {
                    if (response.responseCode === 0) {
                        this.sites = response.data.sites;
                        this.totalRowsSite = response.data.total;
                    } else {
                        this.$bvToast.toast(this.$t(response.data), {
                            title: this.$t('INFO_WARNING'),
                            variant: 'warning',
                            solid: true,
                            autoHideDelay: 1500,
                        });
                    }
                    this.loading = false;
                },
                error => {
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        },
        login(hotel) {
            hotelService.login(hotel.hotelId).then(
                response => {
                    if (response.responseCode === 0) {
                        const localArrToken = localStorage.getItem("arrToken") ? JSON.parse(localStorage.getItem("arrToken")) : [];
                        if (localArrToken && localArrToken.length > 0) {
                            const arr = localArrToken.filter(e => e.hotel.id !== hotel.hotelId);
                            arr.push(response.data);
                            localStorage.setItem("arrToken", JSON.stringify(arr));
                        } else {
                            localArrToken.push(response.data);
                            localStorage.setItem("arrToken", JSON.stringify(localArrToken));
                        }

                        const routeData = this.$router.resolve(
                            {
                                name: "about",
                                params: { hotelIdParam: hotel.hotelId }
                            });
                        window.open(routeData.href, '_blank');
                    } else {
                        this.$bvToast.toast(this.$t(response.data), {
                            title: this.$t('INFO_WARNING'),
                            variant: 'warning',
                            solid: true,
                            autoHideDelay: 1500,
                        });
                    }
                },
                error => {
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        },
        updateIndex(index, item) {
            // console.log(index, item)
            const body = {
                hotelId: item.hotelId,
                index: +index < 0 ? 0 : +index
            };
            hotelService.updateIndex(body).then(
                response => {
                    if (response.responseCode === 0) {
                        _alert(response, this.$t(response.data), false);
                        this.getAllSite();
                    } else {
                        this.$bvToast.toast(this.$t(response.data), {
                            title: this.$t('INFO_WARNING'),
                            variant: 'warning',
                            solid: true,
                            autoHideDelay: 1500,
                        });
                    }
                },
                error => {
                    if (error.status === 403) {
                        this.showAlertLogout();
                    }
                },
            );
        }
    },
    computed: {
        fieldsHotel() {
            return [
                { key: 'hotelId', label: this.$t('HOTEL_CODE'), sortable: true, },
                { key: 'name', label: this.$t('HOTEL_NAME'), sortable: true, },
                { key: 'address', label: this.$t('ADDRESS'), sortable: true, },
                { key: this.user.type === 'ADMIN' ? 'chainName' : null, label: this.$t('SUPPLIER'), sortable: true, },
                { key: 'status', label: this.$t('_LIST_USER.STATUS'), sortable: true, },
                { key: this.user.roleUser === 'ROLE_ADMIN' && this.user.type !== 'ADMIN' ? 'index' : null, label: this.$t('INDEX'), class: "text-right" },
                { key: 'actions', label: this.$t('_LIST_USER.ACTION'), class: 'text-right' },
            ];
        },
        fieldsSite() {
            return [
                { key: 'hotelId', label: this.$t('PLAYGROUND_CODE'), sortable: true, },
                { key: 'name', label: this.$t('PLAY_GROUND_NAME'), sortable: true, },
                { key: 'address', label: this.$t('ADDRESS'), sortable: true, },
                { key: this.user.type === 'ADMIN' ? 'chainName' : null, label: this.$t('SUPPLIER'), sortable: true, },
                { key: 'status', label: this.$t('_LIST_USER.STATUS'), sortable: true, },
                { key: this.user.roleUser === 'ROLE_ADMIN' && this.user.type !== 'ADMIN' ? 'index' : null, label: this.$t('INDEX'), class: "text-right" },
                { key: 'actions', label: this.$t('_LIST_USER.ACTION'), class: 'text-right' },
            ];
        },
    }
};